export default [
    {
        field: 'freedays_proportional_days',
        type: 'text',
        value: '0',
        vuetifyProps: {
            label: 'Numero de días',
        },
        rules:['required','numeric'],
    },
    {
        field: 'freedays_proportional_festive_days',
        type: 'text',
        value: '0',
        vuetifyProps: {
            label: 'Días inhábiles',
        },
        rules:['required','numeric'],
    },
]